export {default as QueryProvider} from './QueryProvider';



// WEBPACK FOOTER //
// ./src/components/QueryProvider/index.ts